import React, { Component } from 'react';

import './Person.scss';

import renderHTML from 'react-render-html';
import Fade from 'react-reveal/Fade';

import {
    images
} from '../settings';

class Person extends Component {

	constructor() {
        super();

        this.images = images;
	}

    componentDidMount() {
    }

    componentWillUnount() {
    }

	render() {
        let itemClasses = [
            'card_person',
            'card_person--' + this.props.label.toLowerCase() 
        ];

        return (
            <div className={ itemClasses.join(' ') }>
                <div className="image">
                    <img className="green_vector" src={ this.images.person_vector } />

                    <Fade bottom>
                        <img src={ this.props.image } />
                    </Fade>
                </div>

                <Fade bottom>
                    <div className="person__info">
                        <span className="gri_label"><text>{ renderHTML(this.props.label) }</text></span>
                        <h3>{ renderHTML(this.props.name) }</h3>
                        <h4>{ renderHTML(this.props.subtitle) }</h4>
                    </div>
                </Fade>
            </div>
    	);
	}
}

export { Person };